import React, {FC} from 'react';
import classNames from 'classnames';

import s from './topSectionPlaceholder.scss';

/**
 * Single line product list
 * @param {PropsType} props - component properties
 * @return {React.ReactElement} rendered component
 */
export const TopSectionPlaceholder: FC = () => {
    return (
        <div className={s.container}>
            <div className={classNames(s.mbg, s.placeholderWithAnimation)} />
            <div className={s.banner} />
            <div className={s.filters}>
                <div className={s.filterButton} />
            </div>
            <div className={s.title} />
        </div>
    );
};
